/**
 * Analytics.js
 *
 * (C) 2017 Segment Inc.
 */
import Analytics from "@segment/analytics.js-core";
import integration from "@segment/analytics.js-integration";

// Create a new `analytics` singleton.
window.analyticsImpl = new Analytics();

window.analyticsImpl.integration = integration;
